import { IBarValue, Data } from "./VerticalBarsValueInterfaces";
import { localeFormattedNumber } from "utilities/utilities";

export const VerticalBarValue = ({ bars, yScale }: IBarValue) => {
    const labelMargin = 30;

    return bars.map(({ data: { data, indexValue }, x, width }: Data, i: number) => {
        let total = 0;

        Object.values(data).forEach((value: number | string) => {
            if (typeof value === "number") {
                total += value;
            }
        });

        return (
            <g transform={`translate(${x}, ${yScale(Number(total)) - labelMargin})`} key={`${indexValue}-${i}`}>
                <text
                    className="bar-total-label"
                    x={width / 2}
                    y={labelMargin / 2}
                    textAnchor="middle"
                    alignmentBaseline="central"
                    style={{
                        fill: "rgb(51, 51, 51)",
                    }}
                >
                    {localeFormattedNumber(data.countryCode as string, total)}
                </text>
            </g>
        );
    });
};
